import Trylleby from './Trylleby';

export default Trylleby;